import React from 'react';
import { connect } from 'react-redux';
import Header from '../../components/Sections/Header';
import Footer from '../../components/Sections/Footer';
import Modal from '../../components/Enhanced/Modal';
class App extends React.Component {
  render() {
    const modalLookup = window.osa && window.osa.commonLookup.modal;
    const appVersion = window.osa && window.osa.appVersion;
    const props = this.props;
    if (!window.dispatch && modalLookup) {

      window.dispatch = (url) => {
        props.dispatch({
          type: 'SHOW_MODAL',
          data: {
            headerText: modalLookup.externalLink.header,
            bodyText: modalLookup.externalLink.body,
            actionButtonText: "OK",
            closeButtonText: "Cancel",
            onActionClicked: () => {
              if (typeof window !== 'undefined') {
                window.open(url, "_blank");
              }
            }
          }
        });
      };
    }
    return (
      <div>
        <Header location={this.props.location} />
        {props.isLoading ? <div className="loading"><i className="fa fa-spinner fa-pulse fa-4x" /></div> : null}
        <Modal {...this.props.modal} />
        <div className="container">{props.children}</div>
        <Footer appVersion={appVersion} />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    isLoading: state.gas.isLoading,
    modal: state.gas.modal

  };
};
export default connect(mapStateToProps)(App);